


























	import { Component, Vue} from "vue-property-decorator";
	import TextHeader from "@/components/Common/TextHeader.vue";
	import SoftwareVideo from '@/components/Software/SoftwareVideo.vue';
	import SoftwareGallery from "@/components/Software/SoftwareGaller.vue";
	@Component({
		components: {
		    TextHeader,
            SoftwareVideo,
            SoftwareGallery,
		}
	})
	export default class SoftwarePage extends Vue{


	}
